import { IconRowInsertBottom } from '@tabler/icons-react';
import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';

/**
 * Adds a row after the selected row.
 */
export default function AddRowAfter({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      label="Vložiť riadok dole"
      icon={<IconRowInsertBottom />}
      onClick={() => editor.chain().focus().addRowAfter().run()}
    />
  );
}
